export default "__VITE_ASSET__BiWalRyJ__"